export default async function getDataAttributes (selectors: any, context?: HTMLElement) {
  return selectors.reduce((data: any, selector: any) => {
    const attributeName = selector.attribute.replace(/-/g, '_'); // Convertir guiones medios a guiones bajos
    const searchContext = context || document;
    const elements = searchContext.querySelectorAll(`[pc="${selector.attribute}"]`);
    
    // Filter out elements that are inside bundle-product containers
    const filteredElements = Array.from(elements).filter((element: any) => {
      // Check if this element is inside a bundle-product container
      return !element.closest('[pc="bundle-product"]');
    });
    
    if (selector.target === 'array') {
      data[attributeName] = filteredElements.map((element: any) => ({
        name: element.name || null,
        value: (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement ? element.value : element.textContent),
      }));
    } else if (filteredElements.length > 0) {
      const element: any = filteredElements[0];
      if (element instanceof HTMLSelectElement) {
        data[attributeName] = element.value; // Obtener solo la opción seleccionada
      } else {
        let value = selector.target ? element.getAttribute(selector.target) : (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement ? element.value : element.textContent);
        if (selector.attribute === 'product-price') {
          value = element.textContent?.replace(/[^0-9.]/g, ''); // Obtener solo el número y el punto decimal
        }
        data[attributeName] = value;
      }
    } else {
      data[attributeName] = null;
    }
    return data;
  }, {});
}